import { DashboardPage } from './DashboardPage';
import { useScreeningDashboardPage } from './useScreeningDashboardPage';

export const ScreeningDashboard = () => {
	const { dashboardPageProps } = useScreeningDashboardPage();

	return <DashboardPage {...dashboardPageProps} />;
};
